import Vue from 'vue';
import Router from 'vue-router';

import MembershipWizard from "./MembershipWizard.vue";
import SelectStudio from "./views/select-studio/index.vue";
import SelectMembership from "./views/select-membership/index.vue";
import Profile from "./views/profile/index.vue";
import Payment from "./views/payment/index.vue";
import Confirmation from "./views/confirmation/index.vue";
import Finished from "./views/finished/index.vue";
import Remind from "./views/remind/index.vue";

Vue.use(Router);

function evaluateBase() {
	const tab = window.sunstonevNext.apps.signup.data.tabname.toLowerCase();
	const path = window.location.pathname;
  return path.split(tab)[0] + tab;
  //return "/trial-month/join";
}

export default new Router({
  mode: "history",
  base: evaluateBase(), //window.sunstonevNext.apps.signup.data.tabname.toLowerCase(),
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/:referredBy?',
      name: 'remind',
      props: (route) => (
        {
          referredBy: route.params.referredBy || "n"
        }
      ),
      redirect: to => ({
        name: "select-membership",
        params: { referredBy: to.params.referredBy || "n" }
      }),
      component: Remind
    },
    {
      path: '/:referredBy/membership',
      component: MembershipWizard,
      props: true,
      children: [
        {
          path: "/",
          name: "select-membership",
          component: SelectMembership,
          meta: {
            step: 2
          }
        },
        
        {
          path: '/:referredBy/profile',
          name: 'profile',
          component: Profile,
          meta: {
            step: 3
          }
        },
        {
          path: '/:referredBy/payment',
          name: 'payment',
          component: Payment,
          meta: {
            step: 4
          }
        },
        {
          path: '/:referredBy/finished',
          name: 'finished',
          component: Finished,
          meta: {
            step: 5
          }
        }
      ]

    }
  ]
});

//{
//  path: '/:referredBy?',
//    name: 'remind',
//    props: (route) => (
//      {
//        referredBy: route.params.referredBy || "n"
//      }
//    ),
//    redirect: to => ({
//      name: "select-studio",
//      params: { referredBy: to.params.referredBy || "n" }
//    }),
//    component: Remind
//},
//{
//  path: '/:referredBy/location',
//    component: MembershipWizard,
//    props: true,
//    children: [
//    {
//      path: "/",
//      name: "select-studio",
//      component: SelectStudio,
//      meta: {
//        step: 1
//      }
//    },
//    {
//      path: '/:referredBy/membership',
//      name: 'select-membership',
//      component: SelectMembership,
//      meta: {
//        step: 2
//      }
//    },
//    {
//      path: '/:referredBy/profile',
//      name: 'profile',
//      component: Profile,
//      meta: {
//        step: 3
//      }
//    },
//    {
//      path: '/:referredBy/payment',
//      name: 'payment',
//      component: Payment,
//      meta: {
//        step: 4
//      }
//    },
//    {
//      path: '/:referredBy/finished',
//      name: 'finished',
//      component: Finished,
//      meta: {
//        step: 5
//      }
//    }
//  ]

//}


//   {
//     path: '/',
//     name: 'remind',
//     redirect: "/location",
//     component: Remind
//   },
//   {
//     path: '/location',
//     component: MembershipWizard,
//     props: true,
//     children: [
//       {
//         path: "/",
//         name: "select-studio",
//         component: SelectStudio,
//         meta: {
//           step: 1
//         }
//       },
//       {
//         path: '/membership',
//         name: 'select-membership',
//         component: SelectMembership,
//         meta: {
//           step: 2
//         }
//       },
//       {
//         path: '/profile',
//         name: 'profile',
//         component: Profile,
//         meta: {
//           step: 3
//         }
//       },
//       {
//         path: '/payment',
//         name: 'payment',
//         component: Payment,
//         meta: {
//           step: 4
//         }
//       },
//       {
//         path: '/finished',
//         name: 'finished',
//         component: Finished,
//         meta: {
//           step: 5
//         }
//       }
//     ]

//   }
